/*@ngInject*/
const UserListActionMediator = function (userListActionRepository) {

    this.importUWLOAs = function (file) {
        return userListActionRepository.importUWLOAs(file);
    };

    this.exportUWLOAs = function () {
        return userListActionRepository.exportUWLOAs();
    };
};

angular.module('umCore')
    .service('userListActionMediator', UserListActionMediator);
